<span>
  {{ item.from | timeDifference : item.to : null }}
</span>
